import React, { Component } from "react";
import Select from "react-select";

const CONTENT_TYPES = ["story", "activity", "quiz", "news"];

const CONTENT_TYPE_LABELS = {
  story: "Story",
  activity: "Activity",
  quiz: "Quiz",
  news: "News",
};

const sectionStyle = {
  border: "1px solid #e8e8e8",
  borderRadius: "8px",
  padding: "14px",
  marginBottom: "14px",
  background: "#fafafa",
};

const ruleRowStyle = {
  display: "flex",
  gap: "8px",
  alignItems: "center",
  marginBottom: "8px",
  flexWrap: "wrap",
};

const addBtnStyle = {
  background: "transparent",
  border: "1px dashed #ff8a23",
  color: "#ff8a23",
  borderRadius: "6px",
  padding: "4px 10px",
  cursor: "pointer",
  fontSize: "13px",
};

const removeBtnStyle = {
  background: "transparent",
  border: "none",
  color: "#cf1322",
  cursor: "pointer",
  fontSize: "16px",
  padding: "0 4px",
};

class ContentPolicyRuleBuilder extends Component {
  getFieldOptions(contentType) {
    const { schema } = this.props;
    if (!schema || !schema[contentType]) return [];
    return Object.entries(schema[contentType]).map(([key, def]) => ({
      value: key,
      label: def.label,
      value_type: def.value_type,
      choices: def.choices || [],
    }));
  }

  getChoiceOptions(contentType, fieldKey) {
    const { schema } = this.props;
    if (!schema || !schema[contentType] || !schema[contentType][fieldKey]) return [];
    const choices = schema[contentType][fieldKey].choices || [];
    return choices.map((c) => ({ value: c, label: c }));
  }

  getValueType(contentType, fieldKey) {
    const { schema } = this.props;
    if (!schema || !schema[contentType] || !schema[contentType][fieldKey]) return null;
    return schema[contentType][fieldKey].value_type;
  }

  handleAddRule = (contentType) => {
    const { policy, onChange } = this.props;
    const current = (policy[contentType] || []).slice();
    current.push({ field: "", value: null });
    onChange({ ...policy, [contentType]: current });
  };

  handleRemoveRule = (contentType, index) => {
    const { policy, onChange } = this.props;
    const current = (policy[contentType] || []).slice();
    current.splice(index, 1);
    const updated = { ...policy };
    if (current.length === 0) {
      delete updated[contentType];
    } else {
      updated[contentType] = current;
    }
    onChange(updated);
  };

  handleFieldChange = (contentType, index, fieldKey) => {
    const { policy, onChange } = this.props;
    const current = (policy[contentType] || []).slice();
    current[index] = { field: fieldKey, value: null };
    onChange({ ...policy, [contentType]: current });
  };

  handleValueChange = (contentType, index, value) => {
    const { policy, onChange } = this.props;
    const current = (policy[contentType] || []).slice();
    current[index] = { ...current[index], value };
    onChange({ ...policy, [contentType]: current });
  };

  renderValuePicker(contentType, rule, index) {
    const vtype = this.getValueType(contentType, rule.field);
    if (!vtype) return null;

    if (vtype === "boolean") {
      const boolOptions = [
        { value: true, label: "Yes / True" },
        { value: false, label: "No / False" },
      ];
      return (
        <div style={{ minWidth: "160px" }}>
          <Select
            options={boolOptions}
            value={boolOptions.find((o) => o.value === rule.value) || null}
            onChange={(opt) => this.handleValueChange(contentType, index, opt ? opt.value : null)}
            placeholder="Select value"
            isClearable
          />
        </div>
      );
    }

    const choiceOptions = this.getChoiceOptions(contentType, rule.field);
    const currentValues = Array.isArray(rule.value)
      ? choiceOptions.filter((o) => rule.value.includes(o.value))
      : [];

    return (
      <div style={{ minWidth: "220px" }}>
        <Select
          isMulti
          options={choiceOptions}
          value={currentValues}
          onChange={(selected) =>
            this.handleValueChange(
              contentType,
              index,
              selected ? selected.map((s) => s.value) : []
            )
          }
          placeholder="Select values..."
        />
      </div>
    );
  }

  render() {
    const { policy, schema } = this.props;
    if (!schema) {
      return (
        <div style={{ color: "#888", fontSize: "13px", padding: "8px 0" }}>
          Loading schema...
        </div>
      );
    }

    return (
      <div>
        {CONTENT_TYPES.map((contentType) => {
          const fieldOptions = this.getFieldOptions(contentType);
          if (fieldOptions.length === 0) return null;
          const rules = policy[contentType] || [];

          return (
            <div key={contentType} style={sectionStyle}>
              <div style={{ fontWeight: 600, marginBottom: "10px", color: "#432666" }}>
                {CONTENT_TYPE_LABELS[contentType]}
              </div>

              {rules.map((rule, index) => {
                const selectedField = fieldOptions.find((o) => o.value === rule.field) || null;
                return (
                  <div key={index} style={ruleRowStyle}>
                    <div style={{ minWidth: "160px" }}>
                      <Select
                        options={fieldOptions}
                        value={selectedField}
                        onChange={(opt) =>
                          this.handleFieldChange(contentType, index, opt ? opt.value : "")
                        }
                        placeholder="Select field"
                        isClearable
                      />
                    </div>
                    {rule.field && this.renderValuePicker(contentType, rule, index)}
                    <button
                      type="button"
                      style={removeBtnStyle}
                      onClick={() => this.handleRemoveRule(contentType, index)}
                      title="Remove rule"
                    >
                      &times;
                    </button>
                  </div>
                );
              })}

              <button
                type="button"
                style={addBtnStyle}
                onClick={() => this.handleAddRule(contentType)}
              >
                + Add rule
              </button>
            </div>
          );
        })}
      </div>
    );
  }
}

export default ContentPolicyRuleBuilder;
